'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccordionHeader = function (_React$Component) {
  _inherits(AccordionHeader, _React$Component);

  function AccordionHeader() {
    _classCallCheck(this, AccordionHeader);

    return _possibleConstructorReturn(this, (AccordionHeader.__proto__ || Object.getPrototypeOf(AccordionHeader)).apply(this, arguments));
  }

  _createClass(AccordionHeader, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          id: 'accordion__header-' + this.props.idx,
          role: 'tab',
          'aria-controls': 'accordion__content-' + this.props.idx,
          'aria-expanded': this.props.open,
          className: 'accordion__header'
        },
        this.props.children
      );
    }
  }]);

  return AccordionHeader;
}(_react2.default.Component);

exports.default = AccordionHeader;


AccordionHeader.propTypes = {
  idx: _propTypes2.default.number,
  children: _propTypes2.default.node.isRequired,
  open: _propTypes2.default.bool
};

AccordionHeader.defaultProps = {
  open: true,
  idx: 0
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/accordion/jsx/AccordionHeader.js
// module id = 571
// module chunks = 4